import { z } from 'zod';

export const TransparencySettingSchema = z.number().optional();

export type TransparencySetting = z.infer<typeof TransparencySettingSchema>;
